import {
    createAxiosWithBaseUrl,
    applyJwtAuth,
    configureRefreshRetry,
    createAuthService,
} from "@repo/utils";
import { ACCESS_STORAGE_KEY, API_URL, API_V2_URL } from "@src/config";

export const publicApi = createAxiosWithBaseUrl(API_URL, {
    withCredentials: false,
});
export const privateApi = createAxiosWithBaseUrl(API_URL, {
    withCredentials: false,
});
export const privateApiV2 = createAxiosWithBaseUrl(API_V2_URL, {
    withCredentials: false,
});

export const auth = createAuthService(privateApi, {
    storageKey: ACCESS_STORAGE_KEY,
    endpoints: {
        login: "/api/auth/login",
        verify: "/api/auth/verify",
        refresh: "/api/auth/refresh",
    },
});

applyJwtAuth(privateApi, auth.getAccessToken);
applyJwtAuth(privateApiV2, auth.getAccessToken);

configureRefreshRetry(privateApi, auth.refresh, {
    onUnauthorizedFinal: () => {
        auth.clear();
        // logout
    },
});

configureRefreshRetry(privateApiV2, auth.refresh, {
    onUnauthorizedFinal: () => {
        auth.clear();
        // logout
    },
});
